const SecHeroSection = ({
  ClassSec = "",
  ClassDiv = "",
  specialHead = "",
  title = "",
  link1 = "",
  link2 = "",
  img = "",
}) => {
  return (
    <section className={ClassSec} id="home">
      <div className="hero-section-content">
        <div className="container ">
          <div className="row align-items-center">
            <div className={ClassDiv}>
              <div className="welcome-content" >
                {" "}
                <h1>{title}</h1>
                <div className="promo-section">
                  <h3 className="special-head dark">{specialHead}</h3>
                </div>
                {/* <p className="w-text fadeInUp" data-wow-delay="0.3s">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet dolorem blanditiis ad perferendis, labore delectus dolor sit amet, adipisicing elit. Eveniet.</p> */}
                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="#about" className="btn more-btn mr-3">
                    {link1}
                  </a>
                  <a
                    href="https://api.whatsapp.com/send/?phone=966122280274"
                    className="btn more-btn"
                  >
                    {link2}
                  </a>
                </div>
              </div>
            </div>
            <div className={ClassDiv}>
              <div className="welcome-content  justify-content-center hideOnMobile">
                <lottie-player
                  src="https://assets8.lottiefiles.com/packages/lf20_q5qeoo3q.json"
                  background="transparent"
                  speed="0.3"
                  style={{ width: "100%", height: "100%" }}
                  loop
                  autoplay
                ></lottie-player>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecHeroSection;
